import styled from 'styled-components';
import { lighten } from 'polished';

import { uri, color, ico } from '../../styles/global';

export const Container = styled.li`
    display: flex;
    flex-direction: column;
    padding: 25px 10px;
    list-style: none;
    border: 1px solid ${lighten(0.04, color.secondary)};
    border-radius: 10px;

    header {
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 15px;

        > img {
            content: url(${props => uri + ico[props.theme]});
        }

        h2 {
            display: flex;
            flex-direction: column;
            margin-left: 18px;
            color: ${color.primary};
            text-transform: uppercase;

            span:first-child {
                font-weight: normal;
                color: #fff;
            }
        }
    }

    > p {
        margin: 25px 0;
        font-size: 13px;
    }

    div {
        height: 160px;
        margin-top: auto;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }

    ul {
        margin-bottom: 15px;
        list-style: none;

        > header {
            margin-top: auto;
            height: 25px;
            font-size: 15px;
            color: ${lighten(0.3, color.primary)};
        }

        li {
            &:before {
                margin-right: 5px;
                content: '•';
                font-size: 24px;
                line-height: 24px;
                vertical-align: middle;
                color: ${props => color[props.theme]};
            }
        }
    }

    a {
        height: 40px;
        margin-top: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid ${lighten(0.3, color.primary)};
        color: ${lighten(0.3, color.primary)};
        text-decoration: none;
        transition: all 0.3s;

        &:first-of-type {
            visibility: ${props => props.visibility};
        }

        &:last-child {
            margin-top: 10px;
        }

        &:hover {
            background: ${lighten(0.02, color.secondary)};
            color: ${lighten(0.04, color.primary)};
            border: 1px solid ${lighten(0.04, color.primary)};
        }

        > p {
            margin-left: 12px;
        }

        > svg path {
            fill: ${props => color[props.theme]};
        }
    }
`;
